import axios from 'axios';
import _ from 'lodash';

const schedule_url = 'schedules/';
const schedule_items_urls = 'schedule-items/';
const routes_url = 'routes/';
const work_orders_url = 'work-orders/';
const profiles_url = 'profiles/';
const assign_routes_url = 'assign-routes/';
const events_url = 'events/';
const other_copilot_url = 'other-copilot/';
const schedule_header_url = 'schedule-header/';

export default {
  async getSchedules() {
    const url = schedule_url + '?is_template=false&';
    return axios.get(url)
      .then((response) => {
        return response.data;
      }).catch(err => {
        console.log(err.response.data);
      })
  },
  async getScheduleTemplates() {
    const url = schedule_url + '?is_template=true&';
    return axios.get(url)
      .then((response) => {
        return response.data
      }).catch(err => {
        console.log(err.response.data);
      });
  },
  async createScheduleTemplate(obj) {
    return axios.post(schedule_url, obj)
      .then((response) => {
        return response.data;
      }).catch(err => {
        console.log(err.response.data);
      });
  },
  async getScheduleItemsData(from, to) {
    const url = schedule_items_urls + `schedule_data/?from=${from}&to=${to}&`;
    return axios.get(url)
      .then((response) => {
        return response.data;
      }).catch(err => {
        console.log(err.response.data);
      });
  },
  async getTemplateScheduleItemsData(schedule_id) {
    const url = schedule_items_urls + `template_data/?id=${schedule_id}&`;
    return axios.get(url)
      .then((response) => {
        return response.data;
      }).catch(err => {
        console.log(err.response.data);
      });
  },
  async getScheduleObj(schedule_id) {
    const url = schedule_url + schedule_id;
    return axios.get(url)
      .then((response) => {
        return response.data;
      }).catch(err => {
        console.log(err.response.data);
      });
  },
  async updateSchedule(obj) {
    const url = schedule_url + `${obj.id}/`;
    return axios.patch(url, obj)
      .then((response) => {
        return response.data;
      }).catch(err => {
        console.log(err.response.data);
      });
  },
  async getScheduleDashboard() {
    return axios.get(schedule_header_url)
      .then((response) => {
        return response.data;
      }).catch(err => {
        console.log(err.response.data);
      });
  },
  async getUnscheduledWOs(schedule_id) {
    const url = routes_url + `unscheduled/?schedule=${schedule_id}`;
    return axios.get(url)
      .then((response) => {
        return response.data;
      }).catch(err => {
        console.log(err.response.data);
      });
  },
  async getRoutesForDateRange(from, to, schedule_id) {
    const url = routes_url + `?date__gte=${from}&date__lte=${to}&schedule=${schedule_id}&`;
    return axios.get(url)
      .then((response) => {
        return response.data
      }).catch(err => {
        console.log(err.response.data);
      });
  },
  async updateRouteWos(routeUpdateArray) {
    const url = routes_url + 'reschedule/';
    return axios.post(url, routeUpdateArray)
      .then((response) => {
        return response.data;
      }).catch(err => {
        console.log(err.response.data);
      });
  },
  async createRoute(obj) {
    let url = routes_url + '?';

    if (obj.other_copilots !== undefined && obj.other_copilots !== null) {
      for (let i = 0; i < obj.other_copilots.length; i++) {
        url += `other_copilot=${obj.other_copilots[i]}&`;
      }
    }

    return axios.post(url, obj)
      .then((response) => {
        return response.data;
      }).catch(err => {
        console.log(err.response.data);
      });
  },
  async getRoute(route_id) {
    const url = routes_url + `${route_id}/`;
    return axios.get(url)
      .then((response) => {
        return response.data;
      }).catch(err => {
        console.log(err.response.data);
      });
  },
  async updateRoute(obj) {
    let url = routes_url + `${obj.id}/?`;

    for (let i = 0; i < obj.other_copilots.length; i++) {
      url += `other_copilot=${obj.other_copilots[i]}&`;
    }

    return axios.patch(url, obj)
      .then((response) => {
        return response.data;
      }).catch(err => {
        console.log(err.response.data);
      });
  },
  async deleteRoute(obj) {
    const url = routes_url + `${obj.id}/`;
    return axios.delete(url)
      .then((response) => {
        return response.data;
      }).catch(err => {
        console.log(err.response.data);
      });
  },
  async deleteOtherCopilot(route_id, copilot_id) {
    const url = other_copilot_url + `?route_id=${route_id}&copilot_id=${copilot_id}&`;
    return axios.delete(url)
      .then((response) => {
        return response.data;
      }).catch(err => {
        console.log(err.response.data);
      });
  },
  async getRouteWOs(route_id) {
    const url = work_orders_url + `?route=${route_id}&`;
    return axios.get(url)
      .then((response) => {
        return response.data;
      }).catch(err => {
        console.log(err.response.data);
      });
  },
  async getSnowRouteWOs(route_id) {
    const url = work_orders_url + `snow_route/?route=${route_id}&`;
    return axios.get(url)
      .then((response) => {
        return response.data;
      }).catch(err => {
        console.log(err.response.data);
      });
  },
  async getScheduleWOs(schedule_id) {
    const url = work_orders_url + `?schedule=${schedule_id}&`;
    return axios.get(url)
      .then((response) => {
        return response.data;
      }).catch(err => {
        console.log(err.response.data);
      });
  },
  async getLeads() {
    const url = profiles_url + '?can_be_lead=true';
    return axios.get(url)
      .then((response) => {
        return _.orderBy(response.data, 'name_display')
      }).catch(err => {
        console.log(err.response.data);
      });
  },
  async assignRoutes(obj) {
    return axios.post(assign_routes_url, obj)
      .then((response) => {
        return response.data;
      }).catch(err => {
        console.log(err.response.data);
      });
  },
  async getCrewVisitsForWO(obj) {
    const url = `crew-visits/?work_order=${obj.id}`;

    return axios.get(url)
      .then((response) => {
        return response.data;
      }).catch(err => {
        console.log(err.response.data);
      });
  },
  async getEvents(from = null, to = null) {
    let url = events_url + '?';

    if (from !== null && from !== undefined) {
      url += `date__gte=${from}&`;
    }

    if (to !== null && to !== undefined) {
      url += `date__lte=${to}&`;
    }

    return axios.get(url)
      .then((response) => {
        return response.data;
      }).catch(err => {
        console.log(err.response.data);
      });
  },
  async getEvent(event_id) {
    const url = events_url + event_id + '/';
    return axios.get(url)
      .then((response) => {
        return response.data;
      }).catch(err => {
        console.log(err.response.data);
      });
  },
  async createEvent(event) {
    return axios.post(events_url, event)
      .then((response) => {
        return response.data;
      }).catch(err => {
        console.log(err.response.data);
      });
  },
  async deleteEvent(event) {
    const url = events_url + `${event.id}/`;
    await axios.delete(url)
      .then((response) => {
        return response.data;
      }).catch(err => {
        console.log(err.response.data);
      });
  },
  async updateEvent(event) {
    const url = events_url + `${event.id}/`;
    return axios.patch(url, event)
      .then((response) => {
        return response.data;
      }).catch(err => {
        console.log(err.response.data);
      });
  },

}
